import React from 'react';
import { Redirect } from 'react-router-dom';

function SalesRedirect() {
    return (<Redirect to="/customer/account/" />);
}

export default SalesRedirect;
